import { render, staticRenderFns } from "./BBtn.vue?vue&type=template&id=4c86acdc&"
import script from "./BBtn.vue?vue&type=script&lang=js&"
export * from "./BBtn.vue?vue&type=script&lang=js&"
import style0 from "./BBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports